let globalBackendApi;
export const getGlobalBackendApi = () => {
    return globalBackendApi;
};
export const setGlobalBackendApi = val => {
    globalBackendApi = val;
};
